export const analyticsJourneyCards = [
  {
    audience: 'Data Teams',
    body: 'Drowning in ad-hoc requests? Help users self-serve with AI they can trust, and free up time for your team.',
    logoAlt: 'Synthesia',
    logoClassName: 'synthesia',
    logoSrc: '/images/customer-logos/synthesia.svg',
    quote:
      'Our big lesson with AI is that it’s about control. When you constrain it and give it context, like Omni’s semantic layer does, you get predictable, reliable results that drive action.',
    href: '/blog/case-study-synthesia',
    tone: 'blue',
  },
  {
    audience: 'Business teams',
    body: 'Tired of waiting for answers? Ask a question with AI chat and get a response instantly.',
    logoAlt: 'Guitar Center',
    logoClassName: 'guitar-center',
    logoSrc: '/images/customer-logos/guitar-center.svg',
    quote:
      'Choosing Omni is solving for more than just BI. We’ve also primed ourselves to leap forward into AI because the semantic model is at the heart of the platform. That’s not true for many other tools.',
    href: '/blog/case-study-guitar-center',
    tone: 'purple',
  },
  {
    audience: 'Product teams',
    body: 'Need an AI win? Implement AI analytics with Omni in weeks instead of derailing core product work.',
    logoAlt: 'BambooHR',
    logoClassName: 'bamboo-hr',
    logoSrc: '/images/customer-logos/bamboo-hr.svg',
    quote:
      'Our customers can build custom reports and dashboards in minutes without ever leaving the BambooHR platform. Our team is pushing the business forward because Omni has unlocked capacity for us.',
    href: '/blog/case-study-bamboohr',
    tone: 'green',
  },
] as const
